import { INSURANCE_PLAN_RISKS, PRICER_TYPES } from "utils/constants";

export const PRICER_RISK_VIEWS = {
  health: "health",
  terminal: "terminal",
  service: "service",
  rateLookup: "rateLookup",
  collective: "collective",
};

export const resolvePricerRiskView = (risk, type) => {
  if (type === PRICER_TYPES.COLLECTIVE) {
    return PRICER_RISK_VIEWS.collective;
  }
  if (risk === INSURANCE_PLAN_RISKS.SPORTS_LEISURE) {
    return PRICER_RISK_VIEWS.rateLookup;
  }
  if (risk === INSURANCE_PLAN_RISKS.TERMINAL) {
    return PRICER_RISK_VIEWS.terminal;
  }
  if (risk === INSURANCE_PLAN_RISKS.SERVICE) {
    return PRICER_RISK_VIEWS.service;
  }
  return PRICER_RISK_VIEWS.health;
};
